var InFlight = InFlight || {};
InFlight.Utils = (function() {
  var hash = function(str) {
    var hash = 5381,
      i = str.length;

    while (i) {
      hash = (hash * 33) ^ str.charCodeAt(--i);
    }

    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
     * integers. Since we want the results to be always positive, convert the
     * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
  };

  var hideGlobalFooter = function() {
    $('#global_footer').css('visibility', 'hidden');
  };

  var showGlobalFooter = function() {
    $('#global_footer').css('visibility', 'visible');
  };


  var _hideLoading = function(){
    setTimeout(InFlightDC.hideLoading);
  }

  var _get = function(url) {
    InFlightDC.showLoading();
    return $.get(url).then(_hideLoading, _hideLoading);
  };

  var _goTo = function(url){
    InFlightDC.showLoading();
    location.href = url;
  }

  var _isTouchDevice = function(){
    return 'ontouchstart' in window || navigator.msMaxTouchPoints;
  }

  
  var _toAnchor = function(url){
    //format the target as a path + query
    var a = $('<a>', {
        href: url
    })[0];
    return a;
}

  var _convertToHref = function(text) {
    var urlRegex = /(?:https?:\/\/)?[-0-9a-zA-Z]{2,63}\.(?:[-0-9a-zA-Z]{2,63}\.)*[a-zA-Z]{2,6}[-a-zA-Z0-9@:%_\+.~#?&\/=]*[a-zA-Z0-9]/g;
    return text.replace(urlRegex, function(url) {
      var url2 =  url.indexOf('http') === 0 ? url : 'http://' + url ;
      return '<a href="' + url2 + '" target="_blank">' + url + '</a>';
    });
  }

  var _linkifyElement = function(selector) {
    // Searches for URLs inside the element and make them clickable
    var element = $(selector)[0];
    if (element != undefined) {
      var $element = $(element);
      $element.html(_convertToHref($element.html()));
    }
  }

  return {
    hash: hash,
    showGlobalFooter: showGlobalFooter,
    hideGlobalFooter: hideGlobalFooter,
    get: _get,
    goTo: _goTo,
    isTouchDevice: _isTouchDevice,
    toAnchor: _toAnchor,
    linkifyElement: _linkifyElement
  };
})();
